/**
 * @generated SignedSource<<6751e9e6b6e0457dd22b93bb8cfa1ff0>>
 * @relayHash 80cddabf1ecdc6a379e88cbd696bcf7c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 80cddabf1ecdc6a379e88cbd696bcf7c

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useTimelineItemsBackQuery$variables = {
  count: number;
  cursor?: string | null | undefined;
  id: string;
};
export type useTimelineItemsBackQuery$data = {
  readonly node: {
    readonly backTimelineItems?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __id: string;
          readonly " $fragmentSpreads": FragmentRefs<"IssueTimelineItem">;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly startCursor: string | null | undefined;
      };
      readonly totalCount: number;
    };
  } | null | undefined;
};
export type useTimelineItemsBackQuery = {
  response: useTimelineItemsBackQuery$data;
  variables: useTimelineItemsBackQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "visibleEventsOnly",
    "value": true
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileResourcePath",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCopilot",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAgent",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = [
  (v18/*: any*/)
],
v20 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "User",
  "abstractKey": null
},
v21 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "EnterpriseUserAccount",
  "abstractKey": null
},
v22 = {
  "kind": "InlineFragment",
  "selections": (v19/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "actor",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v11/*: any*/),
        (v12/*: any*/),
        (v13/*: any*/),
        (v7/*: any*/),
        (v17/*: any*/),
        (v20/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "TimelineEvent",
  "abstractKey": "__isTimelineEvent"
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerDidAuthor",
  "storageKey": null
},
v25 = [
  (v12/*: any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "willCloseTarget",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "referencedAt",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v25/*: any*/),
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v18/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v37 = {
  "alias": "pullTitleHTML",
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDraft",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInMergeQueue",
  "storageKey": null
},
v41 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v36/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v37/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v36/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  }
],
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameHTML",
      "storageKey": null
    },
    (v18/*: any*/),
    (v42/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueUpdateIntent",
  "kind": "LinkedField",
  "name": "intent",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rationale",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    (v10/*: any*/),
    (v44/*: any*/)
  ],
  "type": "LabeledEvent",
  "abstractKey": null
},
v46 = {
  "kind": "InlineFragment",
  "selections": [
    (v43/*: any*/),
    (v10/*: any*/)
  ],
  "type": "UnlabeledEvent",
  "abstractKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "Actor",
  "abstractKey": "__isActor"
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v49 = [
  (v10/*: any*/),
  (v7/*: any*/),
  (v12/*: any*/),
  (v48/*: any*/),
  (v18/*: any*/)
],
v50 = [
  (v10/*: any*/),
  (v12/*: any*/),
  (v48/*: any*/),
  (v18/*: any*/)
],
v51 = {
  "kind": "InlineFragment",
  "selections": (v50/*: any*/),
  "type": "User",
  "abstractKey": null
},
v52 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v12/*: any*/),
    (v48/*: any*/),
    (v14/*: any*/),
    (v16/*: any*/),
    (v15/*: any*/)
  ],
  "type": "Bot",
  "abstractKey": null
},
v53 = {
  "kind": "InlineFragment",
  "selections": (v50/*: any*/),
  "type": "Mannequin",
  "abstractKey": null
},
v54 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    (v12/*: any*/),
    (v48/*: any*/)
  ],
  "type": "Organization",
  "abstractKey": null
},
v55 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "milestoneTitle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "Milestone",
    "kind": "LinkedField",
    "name": "milestone",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v31/*: any*/)
    ],
    "storageKey": null
  }
],
v56 = {
  "kind": "InlineFragment",
  "selections": (v55/*: any*/),
  "type": "MilestonedEvent",
  "abstractKey": null
},
v57 = {
  "kind": "InlineFragment",
  "selections": (v55/*: any*/),
  "type": "DemilestonedEvent",
  "abstractKey": null
},
v58 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "issueField",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": (v19/*: any*/),
        "type": "IssueFieldText",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v19/*: any*/),
        "type": "IssueFieldDate",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v19/*: any*/),
        "type": "IssueFieldNumber",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v19/*: any*/),
        "type": "IssueFieldSingleSelect",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v19/*: any*/),
        "type": "IssueFieldMultiSelect",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v59 = [
  (v10/*: any*/)
],
v60 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": (v59/*: any*/),
    "storageKey": null
  }
],
v61 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "SubscribedEvent",
  "abstractKey": null
},
v62 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "UnsubscribedEvent",
  "abstractKey": null
},
v63 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "MentionedEvent",
  "abstractKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closingProjectItemStatus",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v66 = {
  "kind": "InlineFragment",
  "selections": [
    (v31/*: any*/),
    (v65/*: any*/)
  ],
  "type": "ProjectV2",
  "abstractKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviatedOid",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v35/*: any*/)
  ],
  "storageKey": null
},
v69 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "ReopenedEvent",
  "abstractKey": null
},
v70 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lockReason",
      "storageKey": null
    },
    (v10/*: any*/)
  ],
  "type": "LockedEvent",
  "abstractKey": null
},
v71 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "UnlockedEvent",
  "abstractKey": null
},
v72 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "PinnedEvent",
  "abstractKey": null
},
v73 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "UnpinnedEvent",
  "abstractKey": null
},
v74 = {
  "kind": "InlineFragment",
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "previousTitle",
      "storageKey": null
    }
  ],
  "type": "RenamedTitleEvent",
  "abstractKey": null
},
v75 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v36/*: any*/)
],
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v75/*: any*/),
  "storageKey": null
},
v77 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v75/*: any*/),
    "storageKey": null
  }
],
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockDuration",
  "storageKey": null
},
v79 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v36/*: any*/),
  (v8/*: any*/)
],
v80 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v79/*: any*/),
    "storageKey": null
  }
],
v81 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v79/*: any*/),
    "storageKey": null
  }
],
v82 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v65/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v68/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
],
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v65/*: any*/),
    (v31/*: any*/)
  ],
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "previousStatus",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v87 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "ConvertedFromDraftEvent",
  "abstractKey": null
},
v88 = [
  (v18/*: any*/),
  (v42/*: any*/)
],
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v88/*: any*/),
  "storageKey": null
},
v90 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v91 = [
  (v7/*: any*/),
  (v12/*: any*/),
  (v10/*: any*/)
],
v92 = {
  "kind": "InlineFragment",
  "selections": (v59/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v93 = [
  (v7/*: any*/),
  (v92/*: any*/)
],
v94 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v91/*: any*/),
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v18/*: any*/),
    (v34/*: any*/),
    (v94/*: any*/)
  ],
  "storageKey": null
},
v96 = [
  (v7/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v30/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v33/*: any*/),
      (v95/*: any*/)
    ],
    "type": "Issue",
    "abstractKey": null
  },
  {
    "kind": "InlineFragment",
    "selections": [
      (v10/*: any*/),
      (v37/*: any*/),
      (v31/*: any*/),
      (v32/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v40/*: any*/),
      (v95/*: any*/)
    ],
    "type": "PullRequest",
    "abstractKey": null
  },
  (v92/*: any*/)
],
v97 = [
  (v18/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dataType",
    "storageKey": null
  }
],
v98 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "issueField",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v97/*: any*/),
      "type": "IssueFieldText",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v97/*: any*/),
      "type": "IssueFieldDate",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v97/*: any*/),
      "type": "IssueFieldNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v97/*: any*/),
      "type": "IssueFieldSingleSelect",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v97/*: any*/),
      "type": "IssueFieldMultiSelect",
      "abstractKey": null
    },
    (v92/*: any*/)
  ],
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "actor",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v7/*: any*/),
    (v17/*: any*/),
    (v20/*: any*/),
    (v21/*: any*/),
    (v22/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v100 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IssueComment",
    "kind": "LinkedField",
    "name": "issueComment",
    "plural": false,
    "selections": [
      (v10/*: any*/),
      (v31/*: any*/),
      (v8/*: any*/)
    ],
    "storageKey": null
  },
  (v8/*: any*/),
  (v9/*: any*/),
  (v99/*: any*/)
],
v101 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v18/*: any*/),
    (v94/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v102 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v95/*: any*/)
],
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "blockingIssue",
  "plural": false,
  "selections": (v102/*: any*/),
  "storageKey": null
},
v104 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "blockedIssue",
    "plural": false,
    "selections": (v102/*: any*/),
    "storageKey": null
  }
],
v105 = [
  (v7/*: any*/),
  (v10/*: any*/),
  (v30/*: any*/),
  (v31/*: any*/),
  (v32/*: any*/),
  (v33/*: any*/),
  (v95/*: any*/),
  (v8/*: any*/)
],
v106 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "subIssue",
    "plural": false,
    "selections": (v105/*: any*/),
    "storageKey": null
  }
],
v107 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Issue",
    "kind": "LinkedField",
    "name": "parent",
    "plural": false,
    "selections": (v105/*: any*/),
    "storageKey": null
  }
],
v108 = [
  (v10/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "subject",
    "plural": false,
    "selections": [
      (v7/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v65/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v101/*: any*/)
        ],
        "type": "PullRequest",
        "abstractKey": null
      },
      (v92/*: any*/)
    ],
    "storageKey": null
  }
],
v109 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "canonical",
  "plural": false,
  "selections": (v96/*: any*/),
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCanonicalOfClosedDuplicate",
  "storageKey": null
},
v111 = {
  "alias": null,
  "args": null,
  "concreteType": "ProjectV2",
  "kind": "LinkedField",
  "name": "project",
  "plural": false,
  "selections": [
    (v65/*: any*/),
    (v31/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v112 = [
  (v18/*: any*/),
  (v42/*: any*/),
  (v10/*: any*/)
],
v113 = {
  "alias": null,
  "args": null,
  "concreteType": "IssueType",
  "kind": "LinkedField",
  "name": "issueType",
  "plural": false,
  "selections": (v112/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useTimelineItemsBackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "backTimelineItems",
                "args": (v4/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineDataFragmentSpread",
                            "name": "IssueTimelineItem",
                            "selections": [
                              (v7/*: any*/),
                              (v23/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v24/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Issue",
                                    "kind": "LinkedField",
                                    "name": "issue",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": null,
                                        "kind": "LinkedField",
                                        "name": "author",
                                        "plural": false,
                                        "selections": (v25/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v26/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "IssueComment",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v8/*: any*/),
                                  {
                                    "alias": "innerSource",
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "source",
                                    "plural": false,
                                    "selections": (v41/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "type": "CrossReferencedEvent",
                                "abstractKey": null
                              },
                              (v45/*: any*/),
                              (v46/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "assignee",
                                    "plural": false,
                                    "selections": [
                                      (v47/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v49/*: any*/),
                                        "type": "User",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v49/*: any*/),
                                        "type": "Mannequin",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v7/*: any*/),
                                          (v12/*: any*/),
                                          (v48/*: any*/)
                                        ],
                                        "type": "Organization",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v10/*: any*/),
                                          (v7/*: any*/),
                                          (v12/*: any*/),
                                          (v48/*: any*/),
                                          (v14/*: any*/),
                                          (v16/*: any*/),
                                          (v15/*: any*/)
                                        ],
                                        "type": "Bot",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v44/*: any*/)
                                ],
                                "type": "AssignedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "assignee",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v51/*: any*/),
                                      (v52/*: any*/),
                                      (v53/*: any*/),
                                      (v54/*: any*/),
                                      (v47/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "type": "UnassignedEvent",
                                "abstractKey": null
                              },
                              (v56/*: any*/),
                              (v57/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v58/*: any*/),
                                "type": "IssueFieldAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v58/*: any*/),
                                "type": "IssueFieldChangedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v58/*: any*/),
                                "type": "IssueFieldRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v60/*: any*/),
                                "type": "IssueCommentPinnedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v60/*: any*/),
                                "type": "IssueCommentUnpinnedEvent",
                                "abstractKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "IssueComment_issueComment"
                              },
                              (v61/*: any*/),
                              (v62/*: any*/),
                              (v63/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v33/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "duplicateOf",
                                    "plural": false,
                                    "selections": (v41/*: any*/),
                                    "storageKey": null
                                  },
                                  (v64/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "closer",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v66/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          (v32/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Repository",
                                            "kind": "LinkedField",
                                            "name": "repository",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v18/*: any*/),
                                              (v35/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "type": "PullRequest",
                                        "abstractKey": null
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v31/*: any*/),
                                          (v67/*: any*/),
                                          (v68/*: any*/)
                                        ],
                                        "type": "Commit",
                                        "abstractKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v44/*: any*/)
                                ],
                                "type": "ClosedEvent",
                                "abstractKey": null
                              },
                              (v69/*: any*/),
                              (v70/*: any*/),
                              (v71/*: any*/),
                              (v72/*: any*/),
                              (v73/*: any*/),
                              (v74/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v76/*: any*/)
                                ],
                                "type": "BlockedByAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v10/*: any*/),
                                  (v9/*: any*/),
                                  (v76/*: any*/)
                                ],
                                "type": "BlockedByRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v77/*: any*/),
                                "type": "BlockingAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v77/*: any*/),
                                "type": "BlockingRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "deletedCommentAuthor",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v12/*: any*/),
                                      (v20/*: any*/),
                                      (v22/*: any*/),
                                      (v21/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "CommentDeletedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v78/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": "blockedUser",
                                    "args": null,
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "subject",
                                    "plural": false,
                                    "selections": [
                                      (v12/*: any*/),
                                      (v18/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "UserBlockedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v80/*: any*/),
                                "type": "SubIssueAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v80/*: any*/),
                                "type": "SubIssueRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v81/*: any*/),
                                "type": "ParentIssueAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v81/*: any*/),
                                "type": "ParentIssueRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "ReferencedEvent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v82/*: any*/),
                                "type": "ConnectedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "fromRepository",
                                    "plural": false,
                                    "selections": [
                                      (v83/*: any*/),
                                      (v31/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "TransferredEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v82/*: any*/),
                                "type": "DisconnectedEvent",
                                "abstractKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "MarkedAsDuplicateEvent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "UnmarkedAsDuplicateEvent"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Discussion",
                                    "kind": "LinkedField",
                                    "name": "discussion",
                                    "plural": false,
                                    "selections": [
                                      (v31/*: any*/),
                                      (v32/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "ConvertedToDiscussionEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v8/*: any*/),
                                  (v9/*: any*/),
                                  (v84/*: any*/)
                                ],
                                "type": "AddedToProjectV2Event",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v84/*: any*/)
                                ],
                                "type": "RemovedFromProjectV2Event",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v84/*: any*/),
                                  (v85/*: any*/),
                                  (v86/*: any*/)
                                ],
                                "type": "ProjectV2ItemStatusChangedEvent",
                                "abstractKey": null
                              },
                              (v87/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v89/*: any*/),
                                  (v44/*: any*/)
                                ],
                                "type": "IssueTypeAddedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v89/*: any*/)
                                ],
                                "type": "IssueTypeRemovedEvent",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v10/*: any*/),
                                  (v89/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "IssueType",
                                    "kind": "LinkedField",
                                    "name": "prevIssueType",
                                    "plural": false,
                                    "selections": (v88/*: any*/),
                                    "storageKey": null
                                  },
                                  (v44/*: any*/)
                                ],
                                "type": "IssueTypeChangedEvent",
                                "abstractKey": null
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "IssueFieldChangedEvent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "IssueFieldAddedEvent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "IssueFieldRemovedEvent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "IssueCommentPinnedEvent"
                              },
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "IssueCommentUnpinnedEvent"
                              },
                              (v90/*: any*/)
                            ],
                            "args": null,
                            "argumentDefinitions": []
                          },
                          (v90/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useTimelineItemsBackQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "backTimelineItems",
                "args": (v4/*: any*/),
                "concreteType": "IssueTimelineItemsConnection",
                "kind": "LinkedField",
                "name": "timelineItems",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueTimelineItemsEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isIssueTimelineItems"
                          },
                          (v23/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v24/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Issue",
                                "kind": "LinkedField",
                                "name": "issue",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": (v91/*: any*/),
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v32/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "locked",
                                    "storageKey": null
                                  },
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "author",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v12/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v10/*: any*/),
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "body",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "unfurlReferences",
                                    "value": true
                                  }
                                ],
                                "kind": "ScalarField",
                                "name": "bodyHTML",
                                "storageKey": "bodyHTML(unfurlReferences:true)"
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bodyVersion",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUpdate",
                                "storageKey": null
                              },
                              (v31/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "authorAssociation",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanDelete",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanMinimize",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnminimize",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReport",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReportToMaintainer",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanBlockFromOrg",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnblockFromOrg",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanPin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUnpin",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "App",
                                "kind": "LinkedField",
                                "name": "viaApp",
                                "plural": false,
                                "selections": [
                                  (v18/*: any*/),
                                  (v31/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": "isHidden",
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isMinimized",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "minimizedReason",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "showSpammyBadge",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "createdViaEmail",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsorship",
                                "kind": "LinkedField",
                                "name": "authorToRepoOwnerSponsorship",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isActive",
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "repository",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "owner",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v10/*: any*/),
                                      (v12/*: any*/),
                                      (v31/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v34/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "viewerCanCreateIssues",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "slashCommandsEnabled",
                                    "storageKey": null
                                  },
                                  (v83/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanReadUserContentEdits",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastEditedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserContentEdit",
                                "kind": "LinkedField",
                                "name": "lastUserContentEdit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "editor",
                                    "plural": false,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v31/*: any*/),
                                      (v12/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "pinnedBy",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingMinimizeReason",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingBlock",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingUnblock",
                                    "storageKey": null
                                  }
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ReactionGroup",
                                    "kind": "LinkedField",
                                    "name": "reactionGroups",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "content",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "viewerHasReacted",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                          }
                                        ],
                                        "concreteType": "ReactorConnection",
                                        "kind": "LinkedField",
                                        "name": "reactors",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "nodes",
                                            "plural": true,
                                            "selections": [
                                              (v7/*: any*/),
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v25/*: any*/),
                                                "type": "User",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v12/*: any*/),
                                                  (v14/*: any*/),
                                                  (v15/*: any*/),
                                                  (v16/*: any*/)
                                                ],
                                                "type": "Bot",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v25/*: any*/),
                                                "type": "Organization",
                                                "abstractKey": null
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": (v25/*: any*/),
                                                "type": "Mannequin",
                                                "abstractKey": null
                                              },
                                              (v92/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": "reactors(first:5)"
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "type": "Reactable",
                                "abstractKey": "__isReactable"
                              }
                            ],
                            "type": "IssueComment",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v93/*: any*/),
                                "storageKey": null
                              },
                              (v28/*: any*/),
                              (v29/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": "innerSource",
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "source",
                                "plural": false,
                                "selections": (v96/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "CrossReferencedEvent",
                            "abstractKey": null
                          },
                          (v45/*: any*/),
                          (v46/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v47/*: any*/),
                                  (v51/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v52/*: any*/),
                                  (v92/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v44/*: any*/)
                            ],
                            "type": "AssignedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "assignee",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v51/*: any*/),
                                  (v52/*: any*/),
                                  (v53/*: any*/),
                                  (v54/*: any*/),
                                  (v92/*: any*/),
                                  (v47/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "UnassignedEvent",
                            "abstractKey": null
                          },
                          (v56/*: any*/),
                          (v57/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v98/*: any*/),
                              (v8/*: any*/),
                              (v99/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueFieldTimelineOption",
                                "kind": "LinkedField",
                                "name": "options",
                                "plural": true,
                                "selections": (v88/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "value",
                                "storageKey": null
                              },
                              (v42/*: any*/),
                              (v44/*: any*/)
                            ],
                            "type": "IssueFieldAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v98/*: any*/),
                              (v8/*: any*/),
                              (v99/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "newColor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueFieldTimelineOption",
                                "kind": "LinkedField",
                                "name": "newOptions",
                                "plural": true,
                                "selections": (v88/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "newValue",
                                "storageKey": null
                              },
                              (v44/*: any*/)
                            ],
                            "type": "IssueFieldChangedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v98/*: any*/),
                              (v8/*: any*/),
                              (v99/*: any*/),
                              (v9/*: any*/),
                              (v44/*: any*/)
                            ],
                            "type": "IssueFieldRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v100/*: any*/),
                            "type": "IssueCommentPinnedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v100/*: any*/),
                            "type": "IssueCommentUnpinnedEvent",
                            "abstractKey": null
                          },
                          (v61/*: any*/),
                          (v62/*: any*/),
                          (v63/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v33/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicateOf",
                                "plural": false,
                                "selections": (v96/*: any*/),
                                "storageKey": null
                              },
                              (v64/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "closer",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v66/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v31/*: any*/),
                                      (v32/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Repository",
                                        "kind": "LinkedField",
                                        "name": "repository",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v18/*: any*/),
                                          (v94/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "PullRequest",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v31/*: any*/),
                                      (v67/*: any*/),
                                      (v101/*: any*/)
                                    ],
                                    "type": "Commit",
                                    "abstractKey": null
                                  },
                                  (v92/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              (v44/*: any*/)
                            ],
                            "type": "ClosedEvent",
                            "abstractKey": null
                          },
                          (v69/*: any*/),
                          (v70/*: any*/),
                          (v71/*: any*/),
                          (v72/*: any*/),
                          (v73/*: any*/),
                          (v74/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v103/*: any*/)
                            ],
                            "type": "BlockedByAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v10/*: any*/),
                              (v9/*: any*/),
                              (v103/*: any*/)
                            ],
                            "type": "BlockedByRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v104/*: any*/),
                            "type": "BlockingAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v104/*: any*/),
                            "type": "BlockingRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "deletedCommentAuthor",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  (v12/*: any*/),
                                  (v20/*: any*/),
                                  (v22/*: any*/),
                                  (v21/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "CommentDeletedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v78/*: any*/),
                              (v10/*: any*/),
                              {
                                "alias": "blockedUser",
                                "args": null,
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v18/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "UserBlockedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v106/*: any*/),
                            "type": "SubIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v106/*: any*/),
                            "type": "SubIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v107/*: any*/),
                            "type": "ParentIssueAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v107/*: any*/),
                            "type": "ParentIssueRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "willCloseSubject",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "subject",
                                "plural": false,
                                "selections": (v93/*: any*/),
                                "storageKey": null
                              },
                              (v99/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Commit",
                                "kind": "LinkedField",
                                "name": "commit",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "message",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "messageHeadlineHTML",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "messageBodyHTML",
                                    "storageKey": null
                                  },
                                  (v31/*: any*/),
                                  (v67/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Repository",
                                    "kind": "LinkedField",
                                    "name": "repository",
                                    "plural": false,
                                    "selections": [
                                      (v18/*: any*/),
                                      (v94/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "defaultBranch",
                                        "storageKey": null
                                      },
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "type": "ReferencedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v108/*: any*/),
                            "type": "ConnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Repository",
                                "kind": "LinkedField",
                                "name": "fromRepository",
                                "plural": false,
                                "selections": [
                                  (v83/*: any*/),
                                  (v31/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "TransferredEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v108/*: any*/),
                            "type": "DisconnectedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v99/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "duplicate",
                                "plural": false,
                                "selections": (v96/*: any*/),
                                "storageKey": null
                              },
                              (v109/*: any*/),
                              (v110/*: any*/),
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "viewerCanUndo",
                                "storageKey": null
                              },
                              (v10/*: any*/),
                              {
                                "kind": "ClientExtension",
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "pendingUndo",
                                    "storageKey": null
                                  }
                                ]
                              }
                            ],
                            "type": "MarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v99/*: any*/),
                              (v9/*: any*/),
                              (v109/*: any*/),
                              (v110/*: any*/),
                              (v8/*: any*/)
                            ],
                            "type": "UnmarkedAsDuplicateEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Discussion",
                                "kind": "LinkedField",
                                "name": "discussion",
                                "plural": false,
                                "selections": [
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "ConvertedToDiscussionEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              (v9/*: any*/),
                              (v111/*: any*/)
                            ],
                            "type": "AddedToProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v111/*: any*/)
                            ],
                            "type": "RemovedFromProjectV2Event",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v111/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/)
                            ],
                            "type": "ProjectV2ItemStatusChangedEvent",
                            "abstractKey": null
                          },
                          (v87/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v113/*: any*/),
                              (v44/*: any*/)
                            ],
                            "type": "IssueTypeAddedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v113/*: any*/)
                            ],
                            "type": "IssueTypeRemovedEvent",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v10/*: any*/),
                              (v113/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "IssueType",
                                "kind": "LinkedField",
                                "name": "prevIssueType",
                                "plural": false,
                                "selections": (v112/*: any*/),
                                "storageKey": null
                              },
                              (v44/*: any*/)
                            ],
                            "type": "IssueTypeChangedEvent",
                            "abstractKey": null
                          },
                          (v90/*: any*/),
                          (v92/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Issue",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "80cddabf1ecdc6a379e88cbd696bcf7c",
    "metadata": {},
    "name": "useTimelineItemsBackQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "7bbd726e814957246241666ea2dbddd4";

export default node;
